import * as Icons from "@mui/icons-material";

export { Icons };

export type Icon = keyof typeof Icons;

export const IconNames = Object.keys(Icons) as Array<Icon>;
